import React from 'react';
import { useTranslation } from 'react-i18next';
import _ from 'lodash';
import {
  Tabs,
  DatePicker,
  Table,
  Tag,
  Avatar,
  Modal,
  Upload,
  Button,
  Popconfirm
} from 'antd';
import MainPage from '../../shared-components/main-page/MainPage';
import { H1 } from '../../shared-components/typography/Title';
import Dispatch from './shared-components/Dispatch';
import Receiving from './shared-components/Receiving';
import OnHand from './shared-components/OnHand';

function Charts() {
  const { t, i18n } = useTranslation();

  return (
    <MainPage>
      <H1 text={t('charts')} />
      <div className="space-y-2">
        <Tabs>
          <Tabs.TabPane key="1" tab={t('dispatch')}>
            <Dispatch />
          </Tabs.TabPane>
          <Tabs.TabPane key="2" tab={t('receiving')}>
            <Receiving />
          </Tabs.TabPane>
          <Tabs.TabPane key="3" tab={t('on_hand')}>
            <OnHand />
          </Tabs.TabPane>
        </Tabs>
      </div>
    </MainPage>
  );
}

export default Charts;
